import { Link } from "react-router-dom";

type Props = {
  title?: string;
  message?: string;
};

const ClubCaseAccessRejectedPage = ({
  title = "You are not a Cold Case Agency member yet.",
  message = "Join the club to unlock monthly cases, watch private briefings, and access member-only evidence files.",
}: Props) => {
  return (
    <section className="mx-auto max-w-4xl px-4 pb-10 pt-6 text-white">
      <div className="relative overflow-hidden rounded-3xl border border-amber-300/30 bg-[radial-gradient(circle_at_top_left,rgba(251,191,36,0.2),transparent_38%),radial-gradient(circle_at_bottom_right,rgba(56,189,248,0.18),transparent_42%),linear-gradient(145deg,#111827,#0b1320,#1f1b10)] p-8 shadow-[0_30px_90px_rgba(6,10,25,0.55)]">
        <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(to_right,rgba(255,255,255,0.035)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:24px_24px] opacity-30" />
        <div className="relative">
          <p className="text-xs uppercase tracking-[0.35em] text-amber-200">Access Restricted</p>
          <h1 className="mt-3 text-3xl font-black leading-tight md:text-5xl">{title}</h1>
          <p className="mt-4 max-w-2xl text-zinc-200">{message}</p>

          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/agency/dashboard#club-pricing"
              className="rounded-lg bg-amber-300 px-5 py-2.5 text-sm font-semibold text-[#1b1300]"
            >
              View Membership Pricing
            </Link>
            <Link
              to="/agency/dashboard"
              className="rounded-lg border border-white/25 px-5 py-2.5 text-sm font-semibold"
            >
              Back to Agency Home
            </Link>
          </div>

          <div className="mt-5 rounded-xl border border-white/15 bg-white/5 p-3 text-xs text-zinc-200">
            Membership starts at $6/month and unlocks exclusive mysteries only available to club members.
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClubCaseAccessRejectedPage;
